import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { getModulePage } from "@/lib/pageModuleRegistry";

export interface ResolvedModule { key: string; label: string; enabled: boolean; sort_order: number }

export async function fetchPageModules(slug: string): Promise<ResolvedModule[]> {
  const defs = getModulePage(slug)?.modules ?? [];
  const { data } = await supabase
    .from("page_modules")
    .select("module_key, label, enabled, sort_order")
    .eq("page_slug", slug);
  const rows = new Map((data ?? []).map((r) => [r.module_key, r]));
  return defs
    .map((d, i) => {
      const r = rows.get(d.key);
      return { key: d.key, label: d.label, enabled: r ? r.enabled : true, sort_order: r ? r.sort_order : i };
    })
    .sort((a, b) => a.sort_order - b.sort_order);
}

export function usePageModules(slug: string) {
  return useQuery({
    queryKey: ["page-modules", slug],
    queryFn: () => fetchPageModules(slug),
    staleTime: 2 * 60 * 1000,
  });
}
